exports = module.exports = require("../../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, "\n.sorting[data-v-279b5929] {\n    position: absolute;\n    left: 319px;\n    z-index: 1000;\n    width: 225px;\n    margin-left: 250px\n}\n.box-body[data-v-279b5929] {\n    box-shadow: 0 4px 8px 0 rgba(0, 0, 0, 0.2), 0 6px 20px 0 rgba(0, 0, 0, 0.19)\n}\n.inline[data-v-279b5929] {\n    background-color: rgba(255, 132, 78);\n    color: white\n}\n.addnew[data-v-279b5929] {\n    background-image: linear-gradient(to right, rgba(38, 153, 251), rgba(146, 205, 255));\n    color: white\n}\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader?{"minimize":false,"sourceMap":false}!./~/vue-loader/lib/style-compiler?{"id":"data-v-279b5929","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/components/views/primaryTrip/houseDetails.vue
// module id = 144
// module chunks = 0